import { Image } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { FC } from 'react'

type RolexImageProps = {
  className?: string
  size: string
  mobileImage: AssetsElement
  desktopImage: AssetsElement
}

export const RolexImage: FC<RolexImageProps> = ({ size, mobileImage, desktopImage, className }) => {
  const { height, width } = mobileImage.value[0]
  const { height: desktopHeight, width: desktopWidth } = desktopImage.value[0]

  return (
    <div
      className={cn(
        `mx-auto mb-[60px] w-full lg:mb-[90px]`,
        size !== 'xl' && 'grid w-[86%] grid-cols-6 md:w-[84%] md:grid-cols-12',
        size === 'xl' && 'grid grid-cols-1',
        className,
      )}
    >
      <div
        className={cn(
          'hidden md:block',
          size === 's' && 'col-span-8 col-start-3 lg:col-span-6 lg:col-start-4',
          size === 'm' && 'col-span-10 col-start-2',
          size === 'l' && 'col-span-12',
        )}
        style={{ aspectRatio: `${desktopWidth}/${desktopHeight}` }}
      >
        <Image
          className={cn('h-full w-full object-cover')}
          sources={[
            getKontentImage(desktopImage.value[0]?.url, {
              width: 768,
            }),
            getKontentImage(desktopImage.value[0]?.url, {
              width: 768,
            }),
            getKontentImage(desktopImage.value[0]?.url, {
              width: 1200,
            }),
            getKontentImage(desktopImage.value[0]?.url, {
              width: 1600,
            }),
            getKontentImage(desktopImage.value[0]?.url, {
              width: 2400,
            }),
          ]}
          placeholderSrc={getKontentImage(desktopImage.value[0]?.url, {
            width: 50,
            height: 50,
          })}
          alt={desktopImage.value[0]?.description as string}
        />
      </div>
      <div className="col-span-6 block md:hidden" style={{ aspectRatio: `${width}/${height}` }}>
        <Image
          className="h-full w-full object-cover"
          sources={[
            getKontentImage(mobileImage.value[0]?.url, {
              width: 768,
            }),
            getKontentImage(mobileImage.value[0]?.url, {
              width: 768,
            }),
          ]}
          placeholderSrc={getKontentImage(desktopImage.value[0]?.url, {
            width: 50,
            height: 50,
          })}
          alt={desktopImage.value[0]?.description as string}
        />
      </div>
    </div>
  )
}
